import React, { useEffect, useRef, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { STORAGE_KEY } from "../../constants/constants";
import { LOG_VIEW_ID, MASTER_LIST_ID, MEDIA_LIST_ID, POST_LIST_ID, USER_CREATE_ID, USER_LIST_ID } from "../../helpers/permission/constant-permissions";

export const SidebarContent = (props) => {
  const ref = useRef();
  const path = useLocation();
  const userData = JSON.parse(localStorage.getItem(STORAGE_KEY.USER));

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    const pathName1 = pathName.split("/")[1];
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (
        pathName === items[i].pathname ||
        pathName1 === items[i].pathname.replace("/", "")
      ) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                <span>Dashboards</span>
              </Link>
            </li>
            {/* Check if the user has permission to view the Users menu */}
            {userData?.permission_ids?.includes(USER_LIST_ID) && (
              <li>
                <Link to="/users">
                  <i className="bx bx-user"></i>
                  <span>Users</span>
                </Link>
              </li>
            )}
            {userData?.permission_ids?.includes(MEDIA_LIST_ID) && (<li>
              <Link to="/medias">
                <i className="bx bx-camera"></i>
                <span>Media</span>
              </Link>
            </li>)}

            {userData?.permission_ids?.includes(POST_LIST_ID) && (<li>
              <Link to="/posts">
                <i className="bx bx-note"></i>
                <span>Posts</span>
              </Link>
            </li>)}

            {userData?.permission_ids?.includes(MASTER_LIST_ID) && (<li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>Masters</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/country">Country</Link>
                </li>
                <li>
                  <Link to="/state">State</Link>
                </li>
                <li>
                  <Link to="/district">District</Link>
                </li>
                <li>
                  <Link to="/voices">Voices</Link>
                </li>
                <li>
                  <Link to="/author">Original Author</Link>
                </li>
                <li>
                  <Link to="/genre">Genre</Link>
                </li>
                <li>
                  <Link to="/membership">Membership Plan</Link>
                </li>
                <li>
                  <Link to="/feedback">FeedBack</Link>
                </li>
                <li>
                  <Link to="/banner">Banner</Link>
                </li>
                {/* <li>
                  <Link to="/purchases">Purchase</Link>
                </li> */}
                {userData?.permission_ids?.includes(LOG_VIEW_ID) && (<li>
                  <Link to="/feedback-log">CustomerFeedback</Link>
                </li>)}
              </ul>
            </li>)}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};
